import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const useAnimation = (refs: React.RefObject<SVGSVGElement>[], loaded: boolean) => {

  const timelines = useRef<GSAPTimeline[]>([]);

  useEffect(() => {

    refs.forEach(ref => {

      const timeline = gsap.timeline().pause();

      timeline
        .to(ref.current, {
          duration: 0.25,
          ease: "power2.out",
          y: -10
        })
        .to(ref.current, {
          duration: 0.75,
          ease: "bounce.out",
          y: 0
        });

      timelines.current.push(timeline);
    });


    return () => {
      timelines.current?.forEach(timeline => timeline.kill());
      timelines.current = [];
    }

  }, []);

  useEffect(() => {
    timelines.current.forEach((timeline, i) => {
      loaded ?
        timeline.repeat(0).repeatDelay(0) :
        timeline.repeat(-1).repeatDelay(1).play(i * -0.1);
    });
  }, [loaded]);

  return timelines;
}

export default useAnimation;